import { z } from "zod";

export const createTenantSchema = z.object({
    title: z.string().min(1),
    currency_code: z.string().min(1, "forms.general-validation.currency_id_required"),
    accept_terms: z.literal(true),
});

export type CreateTenantFormData = z.infer<typeof createTenantSchema>;
